// ─────────────────────────────────────────────
//  ChoiceMenu — the big icon+label+explanation buttons the Assign menu is made
//  of: the option list itself, the destination list on Transfer, and the two
//  follow-up choices after a takeover displaces somebody.
//
//  ⚠️ EVERY ROW IS A `menuitem`. BenchAssignFlow's arrow keys move between
//  whatever carries that role anywhere inside the dialog, so a list that forgot
//  it would be reachable by Tab and invisible to the arrows.
//
//  ⚠️ THE EXPLANATION LINE IS NOT DECORATION. Every option in this menu MOVES a
//  real person, and several of them are irreversible from here; the sub-line is
//  where the consequence is stated. It is optional only because the Transfer
//  destinations are just facility names.
// ─────────────────────────────────────────────
import React from "react";
import st from "./benchAssignStyles";

export default function ChoiceMenu({ label, items = [], busy = false }) {
  return (
    <div style={st.choiceCol} role="menu" aria-label={label}>
      {items.map((it) => (
        <button role="menuitem" type="button" key={it.key} style={st.choice} disabled={busy} onClick={it.onPick}>
          <span style={st.choiceIcon}>{it.icon}</span>
          <span>
            <span style={st.choiceLabel}>{it.label}</span>
            {it.sub ? <span style={st.choiceSub}>{it.sub}</span> : null}
          </span>
        </button>
      ))}
    </div>
  );
}
